<template>
  <v-container>
  	<v-app-bar app dense color="grey lighten-2" >
      <img src="@/assets/logo.png" height="50" >
      <v-spacer></v-spacer>
      <div >
      	<v-card class="elevation-0 transparent" :to="{name: 'login'}">
      		Iniciar sesión
      	</v-card>
      </div>
    </v-app-bar>

  	<v-card class="elevation-0">
	  	<v-card-text>
	  		<v-card-title primary-title>
	  			<v-spacer></v-spacer>
	  		  Imágenes de muestra de los PDF
	  			<v-spacer></v-spacer>
	  		</v-card-title>
	  		<v-row class="text-center">
		      <v-col cols="12" xl="2" lg="3" md="4" sm="4" v-for="(ruta, j) in imagenes" :key="j">
		      	<v-card class="elevation-0">
		      		Categoría: {{ruta.categoria}}
			        <v-img
			        	apect-ratio="2"
			          :src="ruta.ruta"
			          class="my-3"
			          contain
			          height="200"
			        />
		      	</v-card>
		      </v-col>
	  		</v-row>
	  	</v-card-text>
    </v-card>
  </v-container>
</template>
<script>
  export default {
    name: 'HelloWorld',

    data: () => ({

    	url: 'https://support-smipack.com/fotos/',
    	carpetas: ['BP','FP','GH','GHS', 'HS','S','SL','T','xp'],
      imagenes: [],
    }),

    created(){
    	this.initialize()
    },

    methods:{
    	initialize(){
    		this.imagenes = []
    		for(const j in this.carpetas){
	    		this.$http.get('fotos-marketing/'+this.carpetas[j]).then(response=>{
	    			for(const i in response.body){
	    				this.imagenes.push({ruta: this.url + this.carpetas[j] + '/' + response.body[i], categoria: this.carpetas[j]})
	    			}
	    		}).catch(error=>{
	    			console.log(error)
	    		})
    		}
    	}
    }
  }
</script>

